// Domain types for the Admin Clients MSPA.

// A row in the clients list table.
export interface Client {
  id: string;
  name: string;
  msaDate?: string;
  domain?: string;
  active?: boolean;
}

// A user-defined-field definition (client-context project variable), used to
// render a dynamic form field and to build the embedded UDF payload on save.
export interface ProjectVariableField {
  name: string;
  label: string;
  variableType: "number" | "text" | "date";
  required: boolean;
  minimum?: number;
  maximum?: number;
  selectOptions: { key: string; value: string; default?: boolean }[];
  position: number;
}

// Controlled values for the client create/edit form.
export interface ClientFormValues {
  name: string;
  domain: string;
  msaDate: string;
  rateTableId: string; // "" = none
  udfValues: Record<string, string>; // keyed by ProjectVariableField.name
}

export const emptyClientForm: ClientFormValues = {
  name: "",
  domain: "",
  msaDate: "",
  rateTableId: "",
  udfValues: {},
};
